/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetDailyOrderIncomings$Params {
  VenueId?: string;
  SelectedDate?: string;
  FiscalPrinterCode?: string;
}

export function getDailyOrderIncomings(http: HttpClient, rootUrl: string, params?: GetDailyOrderIncomings$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, getDailyOrderIncomings.PATH, 'get');
  if (params) {
    rb.query('VenueId', params.VenueId, {});
    rb.query('SelectedDate', params.SelectedDate, {});
    rb.query('FiscalPrinterCode', params.FiscalPrinterCode, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

getDailyOrderIncomings.PATH = '/api/pos/User/getdailyorderincomings';
